import styled from 'styled-components'
import { SidebarLogo } from 'iebt-zing-storybook/dist/pages/Layout/NewSidebar/styles'
import { BgImgContainer, LogoImg } from 'iebt-zing-storybook/dist/pages/Layout/TeiaAuthPageLayout/style'

const publicBase = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '')

export const ESPACO_TEIA_LOGO_URL = `${publicBase}/logo_espaco_teia.png`

export const ESPACO_TEIA_SIDEBAR_LOGO_OPEN_URL = `${publicBase}/logo-espaco-teia-sidebar.png`

export const ESPACO_TEIA_SIDEBAR_LOGO_CLOSED_URL = `${publicBase}/logo_espaco_teia.png`

export const EspacoTeiaSidebarLogoLink = styled.a<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${({ $isOpen }) => ($isOpen ? 'min(300px, 28vh)' : '56px')};
  margin-top: 30px;
`

export const EspacoTeiaSidebarLogoImg = styled.img<{ $isOpen: boolean }>`
  display: block;
  object-fit: contain;
  ${({ $isOpen }) =>
    $isOpen
      ? `
    width: 451px;
    height: 300px;
    max-width: 100%;
    max-height: min(300px, 28vh);
  `
      : `
    width: 56px;
    height: auto;
    max-height: 56px;
  `}
`

export const EspacoTeiaSidebarFooterWrap = styled(SidebarLogo)<{ $marginLeft: string }>`
  margin-left: ${({ $marginLeft }) => $marginLeft};
`

export const EspacoTeiaSidebarFooterImg = styled.img<{ $wide: boolean }>`
  width: ${({ $wide }) => ($wide ? '50px' : '30px')};
`

export const EspacoTeiaAuthBg = styled(BgImgContainer)`
  background: linear-gradient(90deg, #005ca9 0.06%, #4db4ab 99.93%);
`

export const EspacoTeiaAuthLogoLink = styled.a`
  margin: auto;
`

export const EspacoTeiaAuthLogoImg = styled(LogoImg)`
  width: 360px;
  height: 250px;
  cursor: pointer;
  object-fit: contain;
`
